import { EntityList } from '@avangard/utils/entity';

import { ChatMessageEntity } from './chat-message.entity';

import type { Entity } from './chat-message.entity';

class ChatMessageEntityList extends EntityList<ChatMessageEntity> {
    constructor(items: Entity[] | null, count?: number | null) {
        super(ChatMessageEntity, items, count);
    }
}

export { ChatMessageEntityList };
